import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "prod-offers__promo" };
var _hoisted_2 = { class: "prod-promo tooltip-wrapper" };
var _hoisted_3 = ["aria-describedby"];
import Tooltip from "./Tooltip.vue";
import { useTemplateRef } from "vue";
import { uniqueId } from "lodash-es";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Coupon',
    props: {
        coupon: { type: Object, required: true },
        brandName: String,
    },
    setup: function (__props) {
        var props = __props;
        var id = uniqueId('tooltip-');
        var button = useTemplateRef('button');
        var code = props.coupon.code.toUpperCase();
        var percent = props.coupon.percent;
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("button", {
                        class: "prod-promo__teaser tooltip-btn",
                        "aria-describedby": _unref(id),
                        type: "button",
                        ref_key: "button",
                        ref: button
                    }, "\n        -" + _toDisplayString(_unref(percent)) + "% " + _toDisplayString(_unref(code)), 9 /* TEXT, PROPS */, _hoisted_3),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createVNode(Tooltip, {
                        button: button.value,
                        id: _unref(id)
                    }, {
                        default: _withCtx(function () { return [
                            _createElementVNode("p", null, [
                                _cache[0] || (_cache[0] = _createTextVNode("По промокоду ", -1 /* CACHED */)),
                                _createElementVNode("strong", null, _toDisplayString(_unref(code)), 1 /* TEXT */),
                                _createTextVNode(" на все ароматы бренда " + _toDisplayString(__props.brandName) + "\n          скидка ещё ", 1 /* TEXT */),
                                _createElementVNode("strong", null, _toDisplayString(_unref(percent)) + "%", 1 /* TEXT */)
                            ])
                        ]; }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["button", "id"])
                ])
            ]));
        };
    }
});
